import { CLMREL_INIT_LOADING, CLMREL_INIT_SUCCESS, CLMREL_INIT_FAIL, CLMREL_SEL_DATA, CLMREL_LOAD_DATA } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import clone from 'clone'

export const initiateState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  sel: {
    branch: '',
    fund: '',
    tranType1: '',
    docNo: ''
  },
  data: {}
}

export const getters = {

}

export const mutations = {
  [CLMREL_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [CLMREL_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [CLMREL_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [CLMREL_SEL_DATA](state, sel) {
    state.sel.branch = sel.branch
    state.sel.fund = sel.fund
    state.sel.tranType1 = sel.tranType1
    state.sel.docNo = sel.docNo
  },
  [CLMREL_LOAD_DATA](state, data) {
    state.data = data
  }
}

const actions = {
  async clmRelInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.releaseClaimsTxnManagement
    commit(CLMREL_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(CLMREL_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(CLMREL_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state: clone(initiateState),
  getters,
  mutations,
  actions
}
